export class LoginModel {
    email: string;
    password: string;
    stayLogin :boolean;
    
  
  }
  